import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface EfiPaymentsDescriptorCardProps {
    processor: ProcessorDetails
}

const getDescriptorSuffix = (options: Record<string, unknown> | null) => {
    const descriptor = options?.descriptor as { descriptor_suffix?: string } | undefined
    return descriptor?.descriptor_suffix
}

export const EfiPaymentsDescriptorCard = ({ processor }: EfiPaymentsDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const descriptorSuffix = getDescriptorSuffix(processor.options)

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('statementDescriptor')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-muted-foreground">{t('customSuffix')}</p>
                        <p className="font-semibold">{descriptorSuffix || t('notConfigured')}</p>
                    </div>

                    {descriptorSuffix && (
                        <div>
                            <p className="text-sm text-muted-foreground">{t('exampleStatement')}</p>
                            <p className="font-mono text-sm">EFIPAYMENTS*{descriptorSuffix}</p>
                        </div>
                    )}

                    <div className="rounded-lg bg-blue-50 p-4 border border-blue-200">
                        <p className="text-sm text-blue-700">
                            <strong>{t('note')}:</strong> {t('efiPaymentsDescriptorNote') || 'This descriptor will appear on customer bank statements.'}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

